/*
  OG-1 landing personalisation — assets/sg-personalize.js
  Loaded on every page from sections/sg-cart-boot.liquid. Only acts on the
  homepage hero (.sg-scrollhero). Inert until the PostHog feature flag
  "landing-variant" exists and returns "sales" or "service".

  Safe defaults: if consent was not given, PostHog is absent, the flag is
  missing, "control", or anything unexpected, the page is left exactly as shipped.

  All personalised copy lives in VARIANTS below — edit it here and nowhere else.
  Keep it inside the same claims rules as the rest of the site: sourcing,
  process and testing facts only; no health claims; offers must match what is
  actually configured. The delivery threshold is read live from the cart
  settings (window.sgCart.shipThreshold), never typed.
*/
(function () {
  'use strict';

  var BASE_SOURCING =
    'Collected by expert climbers at altitude in the K2 range, then purified for six months in cold spring water, never heated.';

  var VARIANTS = {
    sales: {
      bodyClass: 'sg-var-sales',
      sub: function () {
        var c = window.sgCart || {};
        var pence = Number(c.shipThreshold);
        if (c.country === 'GB' && pence > 0) {
          var pounds = pence % 100 === 0 ? String(pence / 100) : (pence / 100).toFixed(2);
          return BASE_SOURCING + ' Free UK delivery over £' + pounds + '.';
        }
        return null; // keep the shipped sub-line
      },
      labFirst: false
    },
    service: {
      bodyClass: 'sg-var-service',
      sub: function () {
        return 'Independently lab tested, with the reports published. 30-day returns on unopened jars, from a UK-registered company.';
      },
      labFirst: true
    }
  };

  var applied = false;

  function apply(key) {
    if (applied) return;
    var v = VARIANTS[key];
    if (!v) return;
    var hero = document.querySelector('.sg-scrollhero');
    if (!hero) return;
    applied = true;

    document.body.classList.add(v.bodyClass);

    var subEl = hero.querySelector('.sg-scrollhero__sub');
    var text = v.sub && v.sub();
    if (subEl && text) subEl.textContent = text;

    if (v.labFirst) {
      var ctas = hero.querySelector('.sg-scrollhero__ctas');
      var shop = ctas && ctas.querySelector('.sg-scrollhero__btn--primary');
      var lab = ctas && ctas.querySelector('a[href*="/pages/lab-testing"]');
      if (shop && lab && shop !== lab) {
        lab.classList.remove('sg-scrollhero__btn--ghost');
        lab.classList.add('sg-scrollhero__btn--primary');
        shop.classList.remove('sg-scrollhero__btn--primary');
        shop.classList.add('sg-scrollhero__btn--ghost');
        ctas.insertBefore(lab, shop);
      }
    }
  }

  function listen() {
    var ph = window.posthog;
    if (!ph || !ph.onFeatureFlags || !document.querySelector('.sg-scrollhero')) return;
    ph.onFeatureFlags(function () {
      try { apply(ph.getFeatureFlag('landing-variant')); } catch (e) { /* leave page as shipped */ }
    });
  }

  if (window.posthog && window.posthog.__loaded) listen();
  else document.addEventListener('sg:posthog-ready', listen, { once: true });
})();
